import { pdfjs } from "react-pdf";
import { type FlyoutProps } from "../../utils/flyout-props";
import { FlyoutPdfStateProvider } from "./PdfContextProvider/context-flyout-pdf-provider";
import { FlyoutPdfDocument } from "./PdfDocument/PdfDocument";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export function FlyoutPdf({ screen }: FlyoutProps) {
  return (
    <FlyoutPdfStateProvider screen={screen}>
      <FlyoutPdfDocument />
    </FlyoutPdfStateProvider>
  );
}
